export default "__VITE_ASSET__Da9AaZL8__"